import { Button, Typography } from '@mui/material';
import React from 'react';
import { DangerIcon, SuccessIcon } from 'src/icons';
import { PopoverComponentRef } from '../Popover';

interface ConfirmationProps extends PopoverComponentRef {
  variant: 'danger' | 'success' | 'warning' | 'info' | '',
  text?: string;
  confirm: () => void;
}

const Confirmation = function Confirmation(props: ConfirmationProps) {
  const {
    variant,
    text = 'Are you sure?',
    close,
    confirm,
  } = props;
  const getIcon = () => {
    switch (variant) {
      case 'danger':
        return <DangerIcon />;
      case 'warning':
        return <DangerIcon value={{ color: '#F9EB71' }} />;
      case 'success':
        return <SuccessIcon />;
      default: return undefined;
    }
  };

  return (
    <div className="p-6">
      {getIcon()}
      <Typography>{text}</Typography>
      <div className="flex justify-center pt-4 gap-2">
        <Button
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            if (close) close();
          }}
          size="small"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={(event) => {
            event.stopPropagation();
            if (confirm) confirm();
          }}
          size="small"
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

Confirmation.defaultProps = {
  text: '',
};

Confirmation.propTypes = {

};

export default Confirmation;
